import { Button } from "../ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Loader2 } from "lucide-react";
import type { Session } from "./types";

interface SessionSelectorProps {
  sessions: Session[];
  activeSessionIndex: number;
  isLoadingMore: boolean;
  hasMoreSessions: boolean;
  onSessionChange: (index: number) => void;
  onLoadMore: () => void;
  getSessionLabel: (session: Session, index: number) => string;
}

export const SessionSelector = ({
  sessions,
  activeSessionIndex,
  isLoadingMore,
  hasMoreSessions,
  onSessionChange,
  onLoadMore,
  getSessionLabel,
}: SessionSelectorProps) => {
  if (sessions.length === 0 && !hasMoreSessions) return null;

  return (
    <div className="mt-3 flex items-center gap-2">
      {sessions.length > 0 && (
        <Select
          value={activeSessionIndex.toString()}
          onValueChange={(val) => onSessionChange(Number(val))}
        >
          <SelectTrigger className="w-auto min-w-[280px] h-8">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {sessions.map((session, idx) => (
              <SelectItem key={idx} value={idx.toString()}>
                {getSessionLabel(session, idx)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      {hasMoreSessions && (
        <Button
          variant="outline"
          size="sm"
          onClick={onLoadMore}
          disabled={isLoadingMore}
          className="h-8"
        >
          {isLoadingMore ? (
            <>
              <Loader2 className="h-3 w-3 animate-spin mr-1.5" />
              Loading...
            </>
          ) : (
            "Load More"
          )}
        </Button>
      )}
    </div>
  );
};
